import './index.css';
import 'react-toastify/dist/ReactToastify.css';

import { Helmet } from 'react-helmet';
import Spinner from 'react-bootstrap/Spinner';
import { ToastContainer } from "react-toastify";
import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useAuth } from '../../context/AuthContext';
import { getImagemCapa } from '../../services/apiImagem';
import imagemPadrao from '../../shared/assets/logoCard.svg';
import CardAnuncioHome from '../../components/HomePage/cardAnuncioHome';
import { erroToastify, sucessoToastify } from "../../shared/validacaoToastify";
import PainelFiltroAnuncio from '../../components/HomePage/PainelFiltroAnuncio';
import OrdenarAnunciosHome from '../../components/HomePage/ordernarAnunciosHome';
import { getFavorito, postFavorito, deleteFavorito } from '../../services/apiFavorito';
import CarouselAnunciosDestaques from '../../components/HomePage/carouselAnunciosDestaques';
import { getHomeAnuncios, getHomeDestaques, postFiltrarAnunciosHome } from '../../services/apiHome';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHandPeace } from '@fortawesome/free-solid-svg-icons';

interface Anuncio {
    cdAnuncio: number;
    nmAnuncio: string;
    dtPublicacao: Date;
    dsAnuncio: string;
    dmAtivo: boolean;
    vlAnuncio: number;
    nrAnunciada?: number;
    cdUsuario: number;
    cdCategoria: number;
    dmSituacao: boolean;
    cdModelo?: number | null;
    cdCidade: number;
    cdCondicao?: number | null;
    dmTipoAnuncio: boolean;
    dtInclusao: Date;
    dtAlteracao?: Date | null;
    cdUsuarioAlt?: number | null;
    cdUsuarioInc: number;
    nmSigla: string;
    nmCidade: string;
}
interface Destaque {
    cdAnuncio: number;
    nmAnuncio: string;
    imagem: string;
    vlAnuncio: any;
}
interface ImagemData {
    cdImagem: number;
    cdAnuncio: number;
    nmTipoArquivo: string;
    dsArquivoImagem: string;
    dsLinkVideo: string;
    mdArquivo: string;
    cdUsuarioInc: number;
    cdUsuarioAlt: number;
    dtInclusao: string;
    dtAlteracao: string;
    dmSituacao: boolean;
}
interface Favorito {
    cdAnuncio: number;
    cdFavorito: number;
}

export default function HomePage() {
    const location = useLocation();
    const navigate = useNavigate();
    const { isAuthenticated } = useAuth();
    const [anuncios, setAnuncios] = useState<Anuncio[]>([]);
    const [filtroAberto, setFiltroAberto] = useState(false);
    const [paginaAtual, setPaginaAtual] = useState<number>(1);
    const [favoritou, setFavoritou] = useState<boolean>(false);
    const [favoritos, setFavoritos] = useState<Favorito[]>([]);
    const [destaques, setDestaques] = useState<Destaque[]>([]);
    const [ordenacao, setOrdenacao] = useState<string>('padrao');
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [camposFiltrados, setCamposFiltrados] = useState<any>(null);
    const [filtrosAtivos, setFiltrosAtivos] = useState<boolean>(false);
    const [loadingImagens, setLoadingImagens] = useState<boolean>(true);
    const [contadorAnuncios, setContadorAnuncios] = useState<number>(0);
    const [loadingCarousel, setLoadingCarousel] = useState<boolean>(true);
    const [imagens, setImagens] = useState<{ [key: number]: ImagemData[] }>({});
    const [quantidadeBotoesPaginacao, setQuantidadeBotoesPaginacao] = useState(window.innerWidth > 750 ? 10 : 3);
    const mostrarFiltro = () => {
        setFiltroAberto(!filtroAberto);
    };
    const ordernarAnuncio = (opcao: string) => {
        setOrdenacao(opcao);
        setPaginaAtual(1);
        filtrarOuCarregarAnuncios();
    };
    const paginaAnterior = () => {
        if (paginaAtual > 1) {
            setPaginaAtual(paginaAtual - 1);
        }
    };
    const filtrarAnuncios = (filtro: any) => {
        setCamposFiltrados(filtro);
        setPaginaAtual(1);
        setFiltrosAtivos(true);
    };
    const limparFiltros = () => {
        setFiltrosAtivos(false);
        setCamposFiltrados(null);
        carregarAnuncios();
    };
    const validarQuantidadeCaracteresTituloDescricao = (text: string, maxLength: number) => {
        if (text.length > maxLength) {
            return text.substring(0, maxLength) + '...';
        }
        return text;
    };
    const proximaPagina = async () => {
        const quantidadePaginas = Math.ceil(contadorAnuncios / 10);
        if (paginaAtual < quantidadePaginas) {
            setPaginaAtual(paginaAtual + 1);
        }
    };
    const carregarAnuncios = async () => {
        try {
            const resposta = await getHomeAnuncios(paginaAtual.toString(), ordenacao);
            const respostaHomeAnuncio = resposta.listaHomeAnuncio;
            setAnuncios(respostaHomeAnuncio);
            setContadorAnuncios(resposta.contadorAnuncios);
        } catch (error) {
            console.error("Erro ao carregar anúncios:", error);
        }
    };
    const atualizarListaFavoritos = async () => {
        try {
            if (isAuthenticated) {
                const cdUsuario = localStorage.getItem('cdUsuario') || '0';
                const response = await getFavorito(cdUsuario);
                setFavoritos(response.data);
            }
        } catch (error) {
            console.error('Erro ao atualizar lista de favoritos:', error);
        }
    };
    const filtrarOuCarregarAnuncios = async () => {
        if (filtrosAtivos) {
            try {
                const resposta = await postFiltrarAnunciosHome(paginaAtual.toString(), ordenacao, camposFiltrados);
                if (resposta) {
                    const respostaAnunciosFiltrados = resposta.listaAnunciosEncontrados;
                    setContadorAnuncios(resposta.contadorAnuncios);
                    setAnuncios(respostaAnunciosFiltrados);
                }
                else {
                    erroToastify('Nenhum anúncio encontrado');
                }
            } catch (error: any) {
                erroToastify(error.response.data);
            }
        } else {
            carregarAnuncios();
        }
    };
    const handleFavoritarDesfavoritar = async (anuncio: Anuncio) => {
        try {
            const favoritoEncontrado = favoritos.find((favorito) => favorito.cdAnuncio === anuncio.cdAnuncio);
            if (favoritoEncontrado) {
                await desfavoritarAnuncio(anuncio.cdAnuncio, favoritoEncontrado.cdFavorito);
            } else {
                await favoritarAnuncio(anuncio.cdAnuncio);
            }
            setFavoritos((prevFavoritos) => {
                if (favoritoEncontrado) {
                    return prevFavoritos.filter((fav) => fav.cdAnuncio !== anuncio.cdAnuncio);
                } else {
                    const novoFavorito = { cdAnuncio: anuncio.cdAnuncio, cdFavorito: Date.now() }; // cdFavorito fictício
                    return [...prevFavoritos, novoFavorito];
                }
            });
        } catch (error) {
            console.error('Erro ao favoritar/desfavoritar anúncio:', error);
        }
    };
    const favoritarAnuncio = async (cdAnuncio: number) => {
        try {
            const cdUsuario = localStorage.getItem('cdUsuario') || '0';
            const dtAtual = new Date().toISOString();
            const data = {
                cdUsuario: parseInt(cdUsuario),
                cdAnuncio: cdAnuncio,
                dtSelecao: dtAtual,
                cdUsuarioInc: parseInt(cdUsuario),
                cdUsuarioAlt: parseInt(cdUsuario),
                dtInclusao: dtAtual,
                dtAlteracao: dtAtual,
                dmSituacao: true
            };
            await postFavorito(data);
            setFavoritou(true);
            atualizarListaFavoritos();
        } catch (error) {
        }
    };
    const desfavoritarAnuncio = async (cdAnuncio: number, cdFavorito: number) => {
        try {
            const cdUsuario = localStorage.getItem('cdUsuario') || '0';
            const dtAtual = new Date().toISOString();
            const data = {
                cdFavorito: cdFavorito,
                cdUsuario: parseInt(cdUsuario),
                cdAnuncio: cdAnuncio,
                dtSelecao: dtAtual,
                cdUsuarioInc: parseInt(cdUsuario),
                cdUsuarioAlt: parseInt(cdUsuario),
                dtInclusao: dtAtual,
                dtAlteracao: dtAtual,
                dmSituacao: false
            };
            await deleteFavorito({ data });
            setFavoritou(true);
            atualizarListaFavoritos();
        } catch (error) {
        }
    };
    const buscarImagens = async () => {
        try {
            setLoadingImagens(true);
            if (anuncios.length > 0) {
                const imagensPromises = anuncios.map(async (anuncio) => {
                    try {
                        const imagensData = await getImagemCapa(anuncio.cdAnuncio);
                        return { cdAnuncio: anuncio.cdAnuncio, imagensData };
                    } catch (error) {
                        console.error(`Erro ao buscar imagens para o anúncio ${anuncio.cdAnuncio}:`, error);
                        return null;
                    }
                });
                const imagensPorAnuncio = await Promise.all(imagensPromises);
                const imagensPorAnuncioObj: { [key: number]: ImagemData[] } = imagensPorAnuncio.reduce((acc: { [key: number]: ImagemData[] }, imagem) => {
                    if (imagem !== null) {
                        if (!acc[imagem.cdAnuncio]) {
                            acc[imagem.cdAnuncio] = [];
                        }
                        acc[imagem.cdAnuncio].push(imagem.imagensData);
                    }
                    return acc;
                }, {});
                setImagens(imagensPorAnuncioObj);
            }
        } catch (error) {
            console.error("Erro ao buscar imagens:", error);
        } finally {
            setLoadingImagens(false);
        }
    };

    useEffect(() => {
        carregarAnuncios();
    }, [paginaAtual, ordenacao]);
    useEffect(() => {
        filtrarOuCarregarAnuncios();
    }, [paginaAtual, ordenacao, filtrosAtivos, camposFiltrados]);
    useEffect(() => {
        buscarImagens();
    }, [anuncios])
    useEffect(() => {
        atualizarListaFavoritos();
    }, []);
    useEffect(() => {
        if (favoritou) {
            const timer = setTimeout(() => {
                setFavoritou(false);
            }, 500);
            return () => clearTimeout(timer);
        }
    }, [favoritou]);
    useEffect(() => {
        const resizeFiltro = () => {
            setWindowWidth(window.innerWidth);
        };
        window.addEventListener('resize', resizeFiltro);
        return () => {
            window.removeEventListener('resize', resizeFiltro);
        };
    }, []);
    useEffect(() => {
        const resizeFiltro = () => {
            setWindowWidth(window.innerWidth);
        };
        window.addEventListener('resize', resizeFiltro);
        return () => {
            window.removeEventListener('resize', resizeFiltro);
        };
    }, []);
    useEffect(() => {
        const resizeListener = () => {
            const newWidth = window.innerWidth;
            setWindowWidth(newWidth);
            setQuantidadeBotoesPaginacao(newWidth > 750 ? 10 : 3);
        };
        window.addEventListener('resize', resizeListener);
        return () => {
            window.removeEventListener('resize', resizeListener);
        };
    }, []);
    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const successMessage = searchParams.get("successMessage");
        const erroMessage = searchParams.get("erroMessage");
        if (successMessage) {
            sucessoToastify(successMessage);
            navigate("/milshop");
        }
        if (erroMessage) {
            erroToastify(erroMessage);
            navigate("/milshop");
        }
    }, [location.search, navigate]);
    useEffect(() => {
        async function fetchFavoritos() {
            try {
                if (isAuthenticated) {
                    const cdUsuario = localStorage.getItem('cdUsuario') || '0';
                    const response = await getFavorito(cdUsuario);
                    setFavoritos(response.data.map((favorito: any) => ({
                        cdAnuncio: favorito.cdAnuncio,
                        cdFavorito: favorito.cdFavorito
                    })));
                }
            } catch (error) {
            }
        }
        fetchFavoritos();
    }, []);
    useEffect(() => {
        const carregarDestaques = async () => {
            try {
                const resposta = await getHomeDestaques();
                const destaquesFormatados = await Promise.all(resposta.map(async (destaque: any) => {
                    try {
                        const imagem = await getImagemCapa(destaque.cdAnuncio);
                        const imagemUrl = imagem ? `data:image/${imagem.nmTipoArquivo};base64,${imagem.mdArquivo}` : imagemPadrao;
                        return {
                            cdAnuncio: destaque.cdAnuncio,
                            nmAnuncio: validarQuantidadeCaracteresTituloDescricao(destaque.nmAnuncio, 30),
                            imagem: imagemUrl,
                            vlAnuncio: destaque.vlAnuncio ? destaque.vlAnuncio : '0'
                        };
                    } catch (error) {
                        console.error(`Erro ao obter imagem para o destaque ${destaque.cdAnuncio}:`, error);
                        return null;
                    }
                }));
                const destaquesFiltrados = destaquesFormatados.filter(destaque => destaque !== null);
                setDestaques(destaquesFiltrados);
                setLoadingCarousel(false);
            } catch (error) {
                setLoadingCarousel(false);
                console.error(error);
            }
        };
        carregarDestaques();
    }, []);

    return (
        <>
            <section className="containerHome">
                <Helmet>
                    <title>Home</title>
                </Helmet>
                <div className='secaoPainelFiltro'>
                    {(windowWidth >= 700) && (anuncios.length > 0) && (
                        <PainelFiltroAnuncio
                            isOpen={filtroAberto}
                            mostrarFiltro={mostrarFiltro}
                            filtrarCallback={filtrarAnuncios}
                            limparFiltros={limparFiltros}
                        />
                    )}
                    {anuncios.length <= 0 && (
                        <div className='secaoFiltroSemAnuncio' onClick={mostrarFiltro}>
                            <h3>Bem vindo ao Milshop</h3>
                            <h6>Seja o primeiro a anúnciar</h6>
                            <p>No momento, não existem anúncios para filtrar</p>
                            <FontAwesomeIcon
                                icon={faHandPeace}
                                size="4x"
                                color="#002F52"
                            />
                        </div>
                    )}
                    {(windowWidth <= 700) && (anuncios.length > 0) && (
                        <div className="sectionFiltro" onClick={mostrarFiltro}>
                            <p>Filtros</p>
                        </div>
                    )}
                    {filtroAberto && windowWidth <= 700 && anuncios.length > 0 && (
                        <PainelFiltroAnuncio
                            isOpen={filtroAberto}
                            mostrarFiltro={mostrarFiltro}
                            filtrarCallback={filtrarAnuncios}
                            limparFiltros={limparFiltros}
                        />
                    )}
                </div>
                <div className='secaoAnunciosEpaginacao'>
                    <div className='secaoAnunciosDestaques'>
                        <h1>Destaques</h1>
                        {loadingCarousel ? (
                            <div className=' spinnerCarregando'>
                                <Spinner animation="border" role="status">
                                    <span className="sr-only">Carregando...</span>
                                </Spinner>
                            </div>
                        ) : (
                            <CarouselAnunciosDestaques
                                destaques={destaques}
                            />
                        )}
                    </div>
                    <div className="contentWrapper">
                        <div className='secaoCamposAnuncios'>
                            <div className="headerAnunciosLista">
                                <h2>Anúncios</h2>
                                <OrdenarAnunciosHome onOrdenarChange={ordernarAnuncio} />
                            </div>
                            <div className="containerCardAnuncio">
                                {anuncios.map((anuncio) => {
                                    const imagensAnuncio = imagens[anuncio.cdAnuncio] ?? [];
                                    const primeiraImagem = imagensAnuncio.length > 0 ? imagensAnuncio[0] : null;
                                    const imagemUrl = primeiraImagem ? `data:image/${primeiraImagem.nmTipoArquivo};base64,${primeiraImagem.mdArquivo}` : imagemPadrao;

                                    return (
                                        <CardAnuncioHome
                                            key={anuncio.cdAnuncio}
                                            cdUsuario={anuncio.cdUsuario}
                                            cdAnuncio={anuncio.cdAnuncio}
                                            imagem={imagemUrl}
                                            titulo={validarQuantidadeCaracteresTituloDescricao(anuncio.nmAnuncio, 50)}
                                            descricao={validarQuantidadeCaracteresTituloDescricao(anuncio.dsAnuncio, 100)}
                                            tipoAnuncio={anuncio.dmTipoAnuncio ? 'Produto' : 'Serviço'}
                                            cidade={anuncio.nmCidade}
                                            uf={anuncio.nmSigla}
                                            preco={`R$ ${anuncio.vlAnuncio.toFixed(2)}`}
                                            loading={loadingImagens}
                                            isFavorito={favoritos.some((favorito: any) => favorito.cdAnuncio === anuncio.cdAnuncio)}
                                            onClickFavoritar={() => {
                                                handleFavoritarDesfavoritar(anuncio);
                                            }}
                                            favoritado={favoritos.some((favorito) => favorito.cdAnuncio === anuncio.cdAnuncio)}
                                        />
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                    <div className="paginationWrapper">
                        <div className='secaoPaginacaoHome'>
                            <nav aria-label="...">
                                <ul className="pagination">
                                    <li className="page-item" onClick={paginaAnterior}>
                                        <a className="page-link" href="#" tabIndex={-1}>Anterior</a>
                                    </li>
                                    {Array.from({ length: Math.ceil(contadorAnuncios / 5) }, (_, index) => index + 1)
                                        .slice(Math.max(paginaAtual - quantidadeBotoesPaginacao / 2, 0), Math.min(paginaAtual + quantidadeBotoesPaginacao / 2, Math.ceil(contadorAnuncios / 5)))
                                        .map((page) => (
                                            <li className={`page-item ${page === paginaAtual ? 'active' : ''}`} key={page}>
                                                <a className="page-link" href="#" onClick={() => setPaginaAtual(page)}>{page}</a>
                                            </li>
                                        ))}
                                    <li className="page-item" onClick={proximaPagina}>
                                        <a className="page-link" href="#">Próximo</a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </section>
            <ToastContainer />
        </>
    );
}        